import { useEffect, useState } from 'react';
import { useWatch } from 'react-hook-form';
import { useQuery } from '@tanstack/react-query';
import { ProgressSpinner } from 'primereact/progressspinner';
import ErrorMessage from '../../../../components/messages/ErrorMessage';
import { useCompanyContext } from '../../../../context/CompanyContext';
import JobSetupInfoTable from './JobSetupInfoTable';
import { fetchContractsHistory } from '@/src/app/services/accounting/ContractBillingsService';

const ROWS_PER_PAGE = 20;

const JobSetupInfoTableContainer = () => {
  const { selectedCompany } = useCompanyContext();
  const [page, setPage] = useState(0);
  const [rows, setRows] = useState(ROWS_PER_PAGE);
  const startDate = useWatch({ name: 'startDate' });
  const endDate = useWatch({ name: 'endDate' });
  const contract = useWatch({ name: 'contract' });
  const id = useWatch({ name: 'id' });

  useEffect(() => {
    setPage(0);
  }, [startDate, endDate, contract]);

  const { data, isFetching, isError } = useQuery({
    queryKey: [
      'getFormHistory',
      selectedCompany,
      startDate,
      endDate,
      page,
      rows,
      contract,
      id,
    ],
    queryFn: ({ signal }) => {
      return fetchContractsHistory(
        {
          companyID: selectedCompany!.id,
          page,
          amountPerPage: rows,
          startDate,
          endDate,
          contract,
          id,
          submitted: true,
        },
        signal
      );
    },
    refetchOnWindowFocus: false,
    enabled: !!selectedCompany,
    keepPreviousData: true,
  });

  const handlePageChange = (newPage: number, newRows: number) => {
    setPage(newPage);
    setRows(newRows);
  };

  if (isFetching)
    return (
      <div className="text-center mx-auto mt-3">
        <ProgressSpinner />
      </div>
    );

  if (isError)
    return (
      <ErrorMessage
        content={'Failed to obtain data! Please try again later.'}
      />
    );

  return (
    <JobSetupInfoTable
      contracts={data?.data ?? []}
      total={data?.total ?? 0}
      page={page}
      rows={rows}
      onPageChange={handlePageChange}
    />
  );
};

export default JobSetupInfoTableContainer;
